module.exports = __webpack_public_path__ + "static/img/homeTopBg.4b85c05e.png";